import { useState, useRef } from 'react'
import CloseIcon from '../../../assets/icons/close.svg?react';
import SearchBox from '../../../components/SearchBox/SearchBox';
import ResetIcon from '../../../assets/icons/reset.svg?react';
import Pagination from '../../../components/Pagination/Pagination';
import useStationsSimple from '../../../hooks/useStationsSimple';
import { SkeletonTable } from '../../../components/Skeleton';
const StationSearchModal = ({ onClose, selectedStation, onSelect }) => {
  const [searchValue, setSearchValue] = useState('');
  const [canSearch, setCanSearch] = useState(true);
  const searchBoxRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { stations, isLoading, error, totalCount } = useStationsSimple({
    CpoStationName: searchValue,
    page: currentPage,
    pageSize: pageSize,
  });
  const handleSearch = (value) => {
    setSearchValue(value);
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  }
  const handleReset = () => {
    if (searchBoxRef.current) {
      searchBoxRef.current.reset();
    }
    setSearchValue('');
    setCanSearch(true);
  }

  const handleSelect = (station) => {
    onSelect(station);
  }

  const handleSubmit = () => {
    onSelect(selectedStation);
    onClose();
  }
  return (
    <div className="modal-background">
      <div className="modal-container station-search-modal-container">
        <div className="modal-header p-10">
          <h3>충전소 검색</h3>
        </div>
        <button className="close-btn" onClick={onClose}>
          <CloseIcon />
        </button>
        <div className="modal-content p-10">
          <div className='flex gap-4 mb-10'>
            <SearchBox 
              ref={searchBoxRef}
              placeholder="충전소 이름을 입력하세요."
              onSearch={handleSearch}
              showFilter={false}
              onSearchStateChange={setCanSearch}
              defaultValue={searchValue}
              selectedFilterRef={null}
              searchValueRef={null}
            />
            <button className="btn btn-primary px-14" onClick={() => {handleSearch(searchValue)}}>
              검색
            </button>
            <button className="btn big-btn btn-style-2 flex align-center gap-2" onClick={handleReset}>
              <ResetIcon />
              초기화
            </button>
          </div>
          <div className='primary-table'>
            <table>
              {isLoading && (
                <SkeletonTable rows={8} columns={5} />
              )}
              {!isLoading && !error && (
              <>
              <thead>
                <tr>
                  <th>번호</th>
                  <th></th>
                  <th>충전소 이름</th>
                  <th>충전소 식별자</th>
                  <th>충전소 주소</th>
                </tr>
              </thead>
              <tbody>
                {error && (
                  <tr>
                    <td colSpan="8" className="no-data">
                      충전소 데이터를 불러오는데 실패했습니다.
                    </td>
                  </tr>
                )}
                {!isLoading && !error && stations.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="no-data">
                      충전소 데이터가 없습니다.
                    </td>
                  </tr>
                ) : (
                  !isLoading && !error && stations.map((station, idx) => {
                    return (
                      <tr key={station.StationSysId}>
                        <td width="60px">{idx + 1}</td>
                        <td width="30px"><input type="checkbox" checked={selectedStation?.StationSysId === station.StationSysId} onChange={() => handleSelect(station)} /></td>
                        <td>{station.CpoStationName}</td>
                        <td>{station.CpoStationId}</td>
                        <td>{station.Address}</td>
                      </tr>
                    );
                  })
                  )}
                </tbody>
              </>
              )}
            </table>
          </div>
          <div className='pagination-wrapper'>
          <Pagination
            currentPage={currentPage}
            totalPages={Math.max(1, Math.ceil(totalCount / pageSize))}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onPageChange={handlePageChange}
          />
          </div>
          <div className='modal-footer end mt-10'>
            <button className="btn btn-primary big-btn" onClick={handleSubmit}>
              충전소 선택
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StationSearchModal